function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1988(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.35,
    height: 10.18,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4542857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 5.09,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.18,
    width: 24.35,
    height: 10.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1355555555555557
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.4,
    width: 24.35,
    height: 10.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.198
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 25.895,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.39,
    width: 24.35,
    height: 12.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.021666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 37.455,
    fontFamily: "Arial"
  }, "\n        Glades\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 43.52,
    width: 24.35,
    height: 14.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5655555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 50.565000000000005,
    fontFamily: "Arial"
  }, "\n        Gilchrist\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.61,
    width: 24.35,
    height: 15.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.91125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 65.255,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 72.9,
    width: 24.35,
    height: 15.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.98625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 80.845,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.79,
    width: 24.35,
    height: 15.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.178
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 96.73500000000001,
    fontFamily: "Arial"
  }, "\n        Dixie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 104.68,
    width: 24.35,
    height: 17.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5285714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 113.53,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 122.38,
    width: 24.35,
    height: 20.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.285555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 132.665,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 142.95,
    width: 24.35,
    height: 21.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.027142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 153.545,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 164.13,
    width: 24.35,
    height: 22.36,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4719999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 175.31,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 186.5,
    width: 24.35,
    height: 22.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2114285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 197.74,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 208.98,
    width: 24.35,
    height: 22.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 220.375,
    fontFamily: "Arial"
  }, "\n        Gulf\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 231.76,
    width: 24.35,
    height: 25.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 244.475,
    fontFamily: "Arial"
  }, "\n        Hardee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 257.19,
    width: 24.35,
    height: 27.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 270.93,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 284.67,
    width: 24.35,
    height: 27.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 298.47,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 312.27,
    width: 24.35,
    height: 28.23,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 326.385,
    fontFamily: "Arial"
  }, "\n        Hendry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 340.5,
    width: 24.35,
    height: 30.24,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 355.62,
    fontFamily: "Arial"
  }, "\n        DeSoto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 370.74,
    width: 24.35,
    height: 30.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 386.09000000000003,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 401.44,
    width: 24.35,
    height: 31.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.04375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 416.96,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 432.48,
    width: 24.35,
    height: 36.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 450.70000000000005,
    fontFamily: "Arial"
  }, "\n        Okeechobee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 468.93,
    width: 24.35,
    height: 41.12,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 489.49,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 510.05,
    width: 24.35,
    height: 42.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.04375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 531.385,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 552.72,
    width: 24.35,
    height: 46.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 575.865,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 599.01,
    width: 24.35,
    height: 50.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4785714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 624.225,
    fontFamily: "Arial"
  }, "\n        Flagler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 649.44,
    width: 24.35,
    height: 50.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.175,
    y: 674.72,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 0,
    width: 29.52,
    height: 45.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.11,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.87,
    y: 0,
    width: 31.16,
    height: 45.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.193333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.45,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.03,
    y: 0,
    width: 31.16,
    height: 45.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.451428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 100.61,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.19,
    y: 0,
    width: 33.48,
    height: 45.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.782857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.93,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.66,
    y: 0,
    width: 50.31,
    height: 45.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.661666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.815,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.98,
    y: 0,
    width: 60.38,
    height: 45.97,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5969999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.17,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.35,
    y: 0,
    width: 61.79,
    height: 45.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.107777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.245,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Highlands\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.15,
    y: 0,
    width: 65.42,
    height: 45.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.661666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.85999999999996,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.57,
    y: 0,
    width: 67.92,
    height: 45.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.107777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.53,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.49,
    y: 0,
    width: 77.75,
    height: 45.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.567142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 494.365,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.23,
    y: 0,
    width: 82.93,
    height: 45.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.661666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.695,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.17,
    y: 0,
    width: 83.83,
    height: 45.97,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.4925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.0849999999999,
    y: 22.985,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 45.97,
    width: 71.64,
    height: 56.17,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.680833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.17,
    y: 74.055,
    fontFamily: "Arial"
  }, "\n        Indian_River\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 102.14,
    width: 71.64,
    height: 58.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.32625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.17,
    y: 131.445,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 160.75,
    width: 71.64,
    height: 68.49,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.17,
    y: 194.995,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 229.24,
    width: 71.64,
    height: 69.72,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.17,
    y: 264.1,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 298.96,
    width: 71.64,
    height: 71.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.17,
    y: 334.85999999999996,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 370.76,
    width: 71.64,
    height: 79.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.17,
    y: 410.57,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 450.37,
    width: 71.64,
    height: 80.23,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.955
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.17,
    y: 490.485,
    fontFamily: "Arial"
  }, "\n        Okaloosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 530.6,
    width: 71.64,
    height: 82.64,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.234285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.17,
    y: 571.9200000000001,
    fontFamily: "Arial"
  }, "\n        Collier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.35,
    y: 613.24,
    width: 71.64,
    height: 86.76,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.17,
    y: 656.62,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.99,
    y: 45.97,
    width: 80.8,
    height: 84.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.542857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.39,
    y: 88.405,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.78,
    y: 45.97,
    width: 83.89,
    height: 84.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.981666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.725,
    y: 88.405,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.68,
    y: 45.97,
    width: 94.14,
    height: 84.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.2175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.75,
    y: 88.405,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.82,
    y: 45.97,
    width: 104.82,
    height: 84.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.124285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.23,
    y: 88.405,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.64,
    y: 45.97,
    width: 112.26,
    height: 84.87,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.60875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.77,
    y: 88.405,
    fontFamily: "Arial"
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.9,
    y: 45.97,
    width: 128.1,
    height: 84.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.60875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 635.9499999999999,
    y: 88.405,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.99,
    y: 130.84,
    width: 123.74,
    height: 105.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.134
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.85999999999999,
    y: 183.675,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.99,
    y: 236.51,
    width: 123.74,
    height: 106.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.85999999999999,
    y: 289.90999999999997,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.99,
    y: 343.32,
    width: 123.74,
    height: 117.27,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.65875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.85999999999999,
    y: 401.955,
    fontFamily: "Arial"
  }, "\n        Sarasota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.99,
    y: 460.58,
    width: 123.74,
    height: 118.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 39.556666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.85999999999999,
    y: 519.915,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.99,
    y: 579.26,
    width: 123.74,
    height: 120.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.248571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.85999999999999,
    y: 639.63,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.73,
    y: 130.84,
    width: 136.22,
    height: 124.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.815714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.84,
    y: 193.195,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.94,
    y: 130.84,
    width: 157.78,
    height: 124.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.83,
    y: 193.195,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.72,
    y: 130.84,
    width: 186.28,
    height: 124.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.942
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.86,
    y: 193.195,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.73,
    y: 255.56,
    width: 148.1,
    height: 192.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.341666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.78,
    y: 351.96500000000003,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.73,
    y: 448.36,
    width: 148.1,
    height: 251.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.809999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.78,
    y: 574.1800000000001,
    fontFamily: "Arial"
  }, "\n        Palm_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.83,
    y: 255.56,
    width: 150.58,
    height: 276.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.8225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.12,
    y: 393.73,
    fontFamily: "Arial"
  }, "\n        Pinellas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.41,
    y: 255.56,
    width: 181.59,
    height: 276.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.94142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.2049999999999,
    y: 393.73,
    fontFamily: "Arial"
  }, "\n        Broward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.83,
    y: 531.9,
    width: 332.17,
    height: 168.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.915,
    y: 615.9499999999999,
    fontFamily: "Arial"
  }, "\n        Miami-Dade\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1988);
export default __webpack_public_path__ + "static/media/1988.692517eda18edad3c2b33a80a0729a21.svg";
export { ForwardRef as ReactComponent };